// Moengage Event handler
export const createMoengageEvent = (
  eventName: string,
  eventAttributes: {
    [key: string]: string | number | boolean | undefined;
  }
) => {
  try {
    // @ts-ignore
    return Moengage.track_event(eventName, eventAttributes);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error initialising Moengage, check logs for more.');
    return () => {};
  }
};
